import { render } from "./pageHeader.vue?vue&type=template&id=5a7fef4d&scoped=true"
import script from "./pageHeader.vue?vue&type=script&lang=js"
export * from "./pageHeader.vue?vue&type=script&lang=js"

import "./pageHeader.vue?vue&type=style&index=0&id=5a7fef4d&scoped=true&lang=css"

import exportComponent from "/home/app-corporate-consiliumplus/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a7fef4d"]])

export default __exports__